import { toast } from 'react-toastify';
import { setIsLoading } from '../../../../actions/general';
import { callApi } from '../../../../apiCaller';
import {
     API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_DETAIL,
     API_SUBSCRIBER_ORGANIZATION_USER_DETAIL,
     API_SUBSCRIBER_ORGANIZATION_USER_MEMBER,
     DEFAULT_FN,
} from '../../../../constants';
import { cloneDeep, sortOrgMemberRole, toastError } from '../../../../utils';
import { setOrganizationTrainingGroups } from '../TrainingGroups/actions';

export const SET_ORGANIZATION_MEMBERS = 'setOrganizationMembers';
export const ADD_ORGANIZATION_MEMBER = 'addOrganizationMember';
export const UPDATE_ORGANIZATION_MEMBER = 'updateOrganizationMember';
export const DELETE_ORGANIZATION_MEMBER = 'deleteOrganizationMember';

export const setOrganizationMembers = (orgMembers) => {
     return {
          type: SET_ORGANIZATION_MEMBERS,
          payload: orgMembers,
     };
};

export const addOrganizationMember = (orgMember) => {
     return {
          type: ADD_ORGANIZATION_MEMBER,
          payload: orgMember,
     };
};

export const updateOrganizationMember = (orgMember) => {
     return {
          type: UPDATE_ORGANIZATION_MEMBER,
          payload: orgMember,
     };
};

export const deleteOrganizationMember = (orgMemberId) => {
     return {
          type: DELETE_ORGANIZATION_MEMBER,
          payload: orgMemberId,
     };
};

// Organization members
export const fetchOrgMembersRequest =
     (organizationId, setOrgMember = DEFAULT_FN) =>
     (dispatch) => {
          dispatch(setIsLoading(true));

          callApi(API_SUBSCRIBER_ORGANIZATION_USER_MEMBER.replace(':organizationId', organizationId), 'GET')
               .then((response) => {
                    if (response.status !== 200) {
                         toastError(response);
                         return;
                    }

                    const orgUser = response.data.users;
                    dispatch(setOrganizationMembers(orgUser));
                    setOrgMember(sortOrgMemberRole(orgUser));
               })
               .finally(() => {
                    dispatch(setIsLoading(false));
               });
     };

export const addOrganizationMemberRequest = (organizationId, nextDispatch) => (dispatch) => {
     const { listOrgMembers, listMemberRemove, setNewOrgMember, setListMemberRemove } = nextDispatch;

     callApi(API_SUBSCRIBER_ORGANIZATION_USER_MEMBER.replace(':organizationId', organizationId), 'POST', {
          listOrgMembers,
          listMemberRemove,
     })
          .then((response) => {
               if (response.status === 200) {
                    dispatch(setOrganizationMembers(response.data.users));
                    setNewOrgMember(sortOrgMemberRole(cloneDeep(response.data.users)));
                    setListMemberRemove([]);
                    toast.success('Update successfully');
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsLoading(false)));
};

export const updateMemberOfTrainingGroupsRequest = (organizationId, nextDispatch) => (dispatch) => {
     const { countMemberOfTrainingGroups } = nextDispatch;
     callApi(API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_DETAIL.replace(':organizationId', organizationId), 'PUT', countMemberOfTrainingGroups()).then(
          (response) => {
               if (response.status === 200) {
                    dispatch(setOrganizationTrainingGroups(response.data));
               } else {
                    toastError(response);
               }
          }
     );
};

// Organization member
export const fetchOrgMemberRequest = (organizationId, userId, setOrganizationMemberUser) => (dispatch) => {
     dispatch(setIsLoading(true));

     callApi(API_SUBSCRIBER_ORGANIZATION_USER_DETAIL.replace(':organizationId', organizationId).replace(':userId', userId), 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               if (response.data) {
                    const organizationMemberRes = {
                         ...response.data,
                         trainingGroupIds: [...new Set(response.data.trainingGroupIds)],
                    };

                    setOrganizationMemberUser(organizationMemberRes);
               }
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};
